/**
 * A tiny utility for constructing className strings conditionally.
 *
 * @see https://github.com/lukeed/clsx/blob/master/src/lite.js
 */
// TODO: migrate it to more common place
function clsx(...args: unknown[]): string {
    return args.filter(Boolean).join(' ');
}

export default clsx;
